<template>
  <div class="navigation_left">
    <div class="head">
      <img src="../assets/imgs/logo.png" alt="">
    </div>
    <el-menu class="el-menu-vertical-demo" :default-openeds="openeds" @select="handleSelect">
      <el-submenu :index="index.toString()" v-for="(item,index) in navigationList" :key="index">
        <template slot="title">
          <img style="width:20px;height:20px;margin-right:10px;" :src="item.icon" alt="">
          <span>{{item.name}}</span>
        </template>
        <el-menu-item-group :class="$route.fullPath.indexOf(i.path) !== -1 ? 'active' : ''" v-for="(i,index_) in item.child" :key="index_">
          <el-menu-item :index="index_.toString()">{{i.name}}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import navigationList from '../tool/navigation.js'
export default {
  data () {
    return {
      navigationList: navigationList.navigationList,
      openeds: []
    }
  },
  created () {
    this.navigationList.forEach((i, index) => {
      this.openeds.push(index.toString())
    })
    console.log(localStorage.getItem('userType_b'));
    if (localStorage.getItem('userType_b') == 0) {
      console.log(navigationList.navigationList);
      navigationList.navigationList.pop()
      console.log(this.navigationList);
    }
  },
  methods: {
    handleSelect (index, indexPath) {
      console.log(this.$route)
      if (this.$route.fullPath !== this.navigationList[Number(indexPath[0])].child[Number(indexPath[1])].path) {
        this.$router.push({
          path: this.navigationList[Number(indexPath[0])].child[Number(indexPath[1])].path
        })
      }
      console.log(this.navigationList[Number(indexPath[0])].child[Number(indexPath[1])].path)
    }
  }
}
</script>

<style scoped lang="less">
.navigation_left {
  min-height: calc(100vh - 0px);
  background-color: #232b3b;
  .head {
    width: 100%;
    overflow: hidden;
    background-color: #232b3b;
    height: 58px;
    line-height: 58px;
    text-align: center;
    img {
      margin-top: 15px;
    }
    .logo {
      float: left;
      background-color: #fff;
      width: 35px;
      height: 35px;
      position: relative;
      top: 10px;
    }
    .text {
      line-height: 50px;
      text-align: center;
      color: #fff;
      font-size: 20px;
      font-weight: 600;
    }
  }
  width: 100%;
  /deep/.el-menu {
    border: none;
    .active {
      background: linear-gradient(360deg, #297dcf 0%, #399dff 100%);
    }
    .el-menu-item.is-active {
      background-color: transparent;
      color: #fff;
      span {
        color: #fff !important;
      }
    }
    // .el-menu-item-group {
    //   .is-active {
    //     background-color: #1990ff;
    //   }
    // }
    width: 100%;
    background-color: #232b3b;
    .el-menu-item-group__title {
      padding: 0 !important;
    }
    .el-submenu {
      width: 100%;
      .el-submenu__title {
        padding-left: 10% !important;
      }
      .el-menu-item {
        padding-left: 20% !important;
      }
    }
    .el-submenu__icon-arrow {
      right: 10%;
    }
    .el-submenu__title {
      width: 100%;
      color: #fff;
    }
    .el-submenu__title {
      &:hover {
        background-color: rgba(25, 144, 255, 0.6);
      }
    }
    .el-menu-item {
      min-width: 100px;
      color: #fff !important;
      &:hover {
        background-color: rgba(25, 144, 255, 0.6) !important;
      }
    }
    .el-menu--inline {
      background-color: #232b3b !important;
    }
  }
}
</style>
